import React, { useContext } from 'react';
import InfoUpdate from '../../InfoUpdate';
import { goToQA } from '../../helpers';
import Notification from '../../../../../../../../common/Styleguide/Common/Notification';
import { SubmissionContext } from '../../../Context/SubmissionProvider';

type SubmissionTabInfosUpdateProps = {
  goToOverview(): void;
};

const SubmissionTabInfosUpdate: React.FC<SubmissionTabInfosUpdateProps> = ({ goToOverview }) => {
  const { submission, disableDetailsEditing } = useContext(SubmissionContext);

  if (!submission) {
    return null;
  }

  const renderRejectedAlert = () => {
    return (
      <Notification
        theme="danger"
        extraSx={{ mb: '20px' }}
        title="Your submission have been rejected."
        description={<>You can't update your game info anymore.</>}
      />
    );
  };
  const showRejectedAlert = submission.status === 'REJECTED';

  const renderReadOnlyAlert = () => {
    return (
      <Notification
        theme="info"
        extraSx={{ mb: '20px' }}
        title="Your submission details are read-only."
        description={
          <>
            You can still edit <b>game covers</b>, <b>videos</b> and the <b>mobile orientation</b>. Don&apos;t forget to click <b>"Save"</b>{' '}
            after making changes.
          </>
        }
      />
    );
  };
  const showReadOnlyAlert = submission.status !== 'REJECTED' && disableDetailsEditing;

  return (
    <>
      {showRejectedAlert && renderRejectedAlert()}
      {showReadOnlyAlert && renderReadOnlyAlert()}
      <InfoUpdate
        goToOverview={goToOverview}
        goToQA={goToQA}
        showOnlyPrimaryButton // prevent "Go Back to Overview" button to appear
      />
    </>
  );
};

export default SubmissionTabInfosUpdate;
